import React, { useEffect, useState } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { SessionContext } from '../../../shared/context/SessionContext';
import { auth } from '../../../firestoreConfig';

import Login from '../Login/Index';
import Layout from '../Layout/Index';

import Home from '../../../features/components/_DemoComponents/Home/Index';
import Customer from '../../../features/components/_DemoComponents/Customer/Index';
import Product from '../../../features/components/_DemoComponents/Product/Index';
import Configuration from '../../../features/components/_DemoComponents/Configuration/Index';

import Catalog from '../../../features/components/Catalog/Index';
import Category from '../../../features/components/Category/Index';
import Section from '../../../features/components/Section/Index';
import Cover from '../../../features/components/Cover/Index';
import Design from '../../../features/components/Design/Index';
import MyCompany from '../../../features/components/MyCompany/Index';

export default function Index() {
    const [user, setUser] = useState({});
    const [isFirstLoad, setIsFirstLoad] = useState(true);

    useEffect(() => {
        auth.onAuthStateChanged(function (user) {
            if (user)
                setUser({
                    displayNmae: user.displayName,
                    email: user.email,
                    phoneNumber: user.phoneNumber,
                    photoURL: user.photoURL,
                    providerId: user.providerId,
                    uid: user.uid
                });
            else
                setUser({});

            setIsFirstLoad(false);
        });
    }, []);

    if (isFirstLoad) {
        return (<div>Loading</div>);
    }

    const sessionContextConfig = {
        user: user,
        setUser: (user) => { setUser(user); }
    }

    return (
        <SessionContext.Provider value={sessionContextConfig}>
            <BrowserRouter>
                <Routes>
                    <Route exact path="/login" element={<Login />} />
                    <Route exact path="/" element={<Layout />}>
                        <Route exact path="/" element={<Home />} />
                        <Route exact path="/home" element={<Home />} />
                        <Route exact path="/customer" element={<Customer />} />
                        <Route exact path="/product" element={<Product />} />
                        <Route exact path="/configuration" element={<Configuration />} />

                        <Route exact path="/catalog" element={<Catalog />} />
                        <Route exact path="/category" element={<Category />} />
                        <Route exact path="/section" element={<Section />} />
                        <Route exact path="/cover" element={<Cover />} />
                        <Route exact path="/design" element={<Design />} />
                        <Route exact path="/my-company" element={<MyCompany />} />
                    </Route>
                </Routes>
            </BrowserRouter>
        </SessionContext.Provider>
    );
}